import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { loadingscreen } from "../../Store";
import VeirfySuccess from "./VeirfySuccess";
import VerifyFail from "./VerifyFail";
import HomeNavbar from "../Homes/Components/HomeNavbar";
import HomeFooter from "../Homes/Components/HomeFooter";

const VerifyContainer = () => {
  const setLoading = useSetRecoilState(loadingscreen);
  const { token } = useParams();
  const [verify, setVerify] = useState(false);
  const getData = () => {
    setLoading(true);
    axios
      .get(`/register/${token}/verify`)
      .then(function (response) {
        // handle success
        setVerify(true);
        setLoading(false);
        // console.log(response.data);
      })
      .catch(function (error) {
        // handle error
        setVerify(false);
        setLoading(false);
        // console.log(error);
      });
  };

  useEffect(() => {
    getData();
    return () => {};
    // eslint-disable-next-line
  }, []);
  return (
    <div className="min-h-screen flex flex-col justify-between bg-white">
      <HomeNavbar />
      <div className="p-8 text-center">
        {verify ? <VeirfySuccess /> : <VerifyFail />}
      </div>
      <HomeFooter />
    </div>
  );
};

export default VerifyContainer;
